import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { QuillModule } from 'ngx-quill';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { ChatComponent } from './chat.component';
import { ThreadStatusComponent } from './thread-status/thread-status.component';
import { DevBackendToggleComponent } from './dev-backend-toggle/dev-backend-toggle.component';
import { ChatMessagesAreaComponent } from './chat-messages-area/chat-messages-area.component';
import { ArtifactZipPreviewComponent } from './artifact-zip-preview/artifact-zip-preview.component';
import { HtmlPreviewerComponent } from './html-previewer/html-previewer.component';
import { WelcomeStateComponent } from './welcome-state/welcome-state.component';
import { EnhancedSettingsPopoverComponent } from './input-container/enhanced-settings-popover/enhanced-settings-popover.component';
import { PromptPopoverComponent } from './input-container/prompt-popover/prompt-popover.component';
import { AgentSelectorPopoverComponent } from './input-container/agent-selector-popover/agent-selector-popover.component';
import { ContextReferencePopoverComponent } from './input-container/context-reference-popover/context-reference-popover.component';
import { ThreadDetailsPopoverComponent } from './input-container/thread-details-popover/thread-details-popover.component';
import { ThreadActionsMenuComponent } from './thread-actions-menu/thread-actions-menu.component';
import { ThreadTodoPopoverComponent } from './thread-todo-popover/thread-todo-popover.component';
import { InputContainerComponent } from './input-container/input-container.component';
import { ChatConnectorsModalModule } from './input-container/chat-connectors-modal/chat-connectors-modal.module';
import { AttachedContextComponent } from './input-container/attached-context/attached-context.component';
import { ChatDevicesModalComponent } from './input-container/chat-devices-modal/chat-devices-modal.component';
import { ChatDeviceCommandTerminalComponent } from './input-container/chat-devices-modal/chat-device-command-terminal/chat-device-command-terminal.component';
import { UiElementsModule } from '../../elements/ui-elements.module';
import { UiTooltipDirective } from '../../elements/ui-tooltip/ui-tooltip.directive';

@NgModule({
  declarations: [
    ChatComponent,
    ThreadStatusComponent,
    DevBackendToggleComponent,
    ChatMessagesAreaComponent,
    ArtifactZipPreviewComponent,
    HtmlPreviewerComponent,
    WelcomeStateComponent,
    EnhancedSettingsPopoverComponent,
    PromptPopoverComponent,
    AgentSelectorPopoverComponent,
    ContextReferencePopoverComponent,
    ThreadDetailsPopoverComponent,
    ThreadActionsMenuComponent,
    ThreadTodoPopoverComponent,
    InputContainerComponent,
    AttachedContextComponent,
    ChatDevicesModalComponent,
    ChatDeviceCommandTerminalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    UiElementsModule,
    UiTooltipDirective,
    ChatConnectorsModalModule,
    PopoverModule,
    TooltipModule,
    ModalModule,
    MonacoEditorModule.forRoot(),
    AngularFireStorageModule,
    QuillModule
  ],
  exports: [
    ChatComponent,
    InputContainerComponent
  ]
})
export class ChatModule { }
